export default __webpack_public_path__ + "css/warrantyClaim.bundle.css";